import {httpGetDiagnoses, HttpGetDiagnosesOptions} from '@/features/projects/http/projects.http'
import {HttpGetSpelicialistsResponse} from '@/features/projects/specialists/http/specialists.http'
import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'

export const useGetDiagnoses = ({
    params,
    options
}: {
    params: HttpGetDiagnosesOptions['params']
    options: Pick<UseInfiniteQueryOptions<HttpGetSpelicialistsResponse>, 'enabled'>
}) =>
    useInfiniteQuery({
        queryKey: [QUERY_KEYS.DIAGNOSES, params],
        queryFn: ({pageParam = 1}) => httpGetDiagnoses({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
